"use client";

import { ArrowDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Climate() {
  const headlineWords1 = ["Das", "Ducted AC", "System."];
  const headlineWords2 = ["Perfektes", "Raumklima", "ohne", "sichtbare", "Geräte."];
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.15
  });
  const {
    ref: labelRef,
    isVisible: labelVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: paraRef,
    isVisible: paraVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.2
  });
  const {
    ref: infoRef,
    isVisible: infoVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const infoRows = [{
    label: "Effizienz",
    value: "Hocheffizientes Heizen"
  }, {
    label: "Installation",
    value: "Versteckt im Dachboden"
  }, {
    label: "Konformität",
    value: "EWärmeG BW erfüllt"
  }];
  return <section data-section-id="2784" id="ewärmeg-bw-einfach-erfüllt" className="dark bg-background text-foreground min-h-[75vh] flex items-center py-20 md:py-28 px-6 md:px-12 lg:px-16">
      <div className="w-full max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-y-12 md:gap-x-8">
          {}
          <div ref={labelRef} className={`md:col-span-4 md:pt-4 transition-all duration-700 ease-out ${labelVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <p className="font-mono text-xs uppercase tracking-widest text-chart-1">
              § NABER AIRCONDUCT — DUCTED AC SYSTEM
            </p>
            <div className="mt-6 h-px w-12 bg-border" />
            <p className="mt-6 font-serif italic text-lg md:text-xl text-foreground/80 leading-relaxed">
              Kühlen und Heizen,
              <br />
              komplett unsichtbar.
            </p>
          </div>

          {}
          <div className="md:col-span-8 md:col-start-5">
            <h1 ref={headlineRef} className="font-default font-serif font-light leading-[0.95] tracking-tight text-foreground" style={{
            fontSize: "clamp(3.5rem, 9vw, 8.25rem)"
          }}>
              <span className="block overflow-hidden">
                {headlineWords1.map((word, i) => <span data-index={i} key={`l1-${i}`} className="inline-block mr-[0.25em] transition-all duration-700 ease-out" style={{
                transitionDelay: `${i * 90}ms`,
                opacity: headlineVisible ? 1 : 0,
                transform: headlineVisible ? "translateY(0)" : "translateY(40%)"
              }}>
                    {word}
                  </span>)}
              </span>
              <span className="block italic mt-2 md:mt-3" style={{
              color: "var(--chart-1)"
            }}>
                {headlineWords2.map((word, i) => <span data-index={i} key={`l2-${i}`} className="inline-block mr-[0.25em] transition-all duration-700 ease-out" style={{
                transitionDelay: `${(headlineWords1.length + i) * 90}ms`,
                opacity: headlineVisible ? 1 : 0,
                transform: headlineVisible ? "translateY(0)" : "translateY(40%)"
              }}>
                    {word}
                  </span>)}
              </span>
            </h1>

            {}
            <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-8 gap-y-12 md:gap-x-8">
              <p ref={paraRef} className={`md:col-span-5 font-default text-base md:text-lg leading-relaxed text-muted-foreground transition-all duration-700 ease-out ${paraVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
                Unser Ducted AC System wird diskret im Dachboden installiert. Genießen Sie zugfreie Kühlung im Sommer und hocheffiziente Wärme im Winter, während Sie spielend leicht die gesetzlichen Vorgaben erfüllen.
              </p>

              <div ref={infoRef} className={`md:col-span-3 transition-all duration-700 ease-out ${infoVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
                <div className="flex flex-col">
                  {infoRows.map((row, i) => <div data-index={i} key={i} className={`flex items-baseline justify-between gap-4 py-3 font-mono text-xs uppercase tracking-wider ${i !== 0 ? "border-t border-border" : ""}`}>
                      <span className="text-muted-foreground">
                        {row.label}
                      </span>
                      <span className="text-foreground text-right">
                        {row.value}
                      </span>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </div>

        {}
        <div ref={ctaRef} className={`mt-20 md:mt-28 flex justify-center md:justify-start md:pl-[33.333%] transition-all duration-700 ease-out ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Button asChild variant="ghost" size="lg" className="group font-mono text-xs uppercase tracking-widest text-foreground hover:bg-transparent hover:text-chart-1 px-0 has-[>svg]:px-0">
            <Link to="/SolutionPage" className="flex items-center gap-2">
              <span className="relative pb-1 after:absolute after:left-0 after:bottom-0 after:h-px after:w-full after:bg-foreground after:transition-opacity after:duration-300 group-hover:after:opacity-50">
                Mehr zur Lösung
              </span>
              <ArrowDown className="ml-2 size-4 transition-transform duration-300 group-hover:translate-y-1" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}